export default __webpack_public_path__ + "static/media/no-avatar.a21de03d.svg";